import { gql } from 'graphql-request';
import { graphqlClient } from '../client';

/**
 * GraphQL mutation for updating an existing pricing metric
 */
const UPDATE_PRICING_METRIC_MUTATION = gql`
  mutation UpdatePricingMetric($id: ID!, $input: PricingMetricInput!) {
    updatePricingMetric(id: $id, input: $input) {
      id
      display_name
      modality
      sample_values
    }
  }
`;

/**
 * Type for the update pricing metric input
 */
export interface UpdatePricingMetricInput {
  display_name: string;
  modality?: string;
  sample_values?: string[];
  page_id: string;
}

/**
 * Type for the update pricing metric response
 */
export interface UpdatePricingMetricResponse {
  updatePricingMetric: {
    id: string;
    display_name: string;
    modality?: string | null;
    sample_values?: string[] | null;
  };
}

/**
 * GraphQL mutation to update an existing pricing metric
 * 
 * @param id The ID of the pricing metric to update
 * @param input The pricing metric data to update
 * @returns Response containing the updated pricing metric data
 */
export async function updatePricingMetricMutation(
  id: string,
  input: UpdatePricingMetricInput
): Promise<UpdatePricingMetricResponse> {
  try {
    console.log(`🔄 [GraphQL] Updating pricing metric: ${id}`, input);
    
    // Execute the GraphQL mutation
    const response = await graphqlClient.request<UpdatePricingMetricResponse>(
      UPDATE_PRICING_METRIC_MUTATION,
      { id, input }
    );
    
    console.log('✅ [GraphQL] Pricing metric update response:', response);
    
    return response;
  } catch (error) {
    console.error('❌ [GraphQL] Error updating pricing metric:', error);
    throw error;
  }
}
